"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDICARE_TAX_1099 = exports.SOCIAL_SECURITY_1099 = exports.ADDTL_MEDICARE_TAX = exports.MEDICARE_TAX = exports.MAX_SOCIAL_SECURITY_PAID = exports.SOCIAL_SECURITY_TAX = exports.filingDetail = void 0;
// Format for tax brackets below [bottom range, top range, tax rate]
var SINGLE_TAX_INCOME_THRESHOLDS = [
    [0, 11000, 0.1],
    [11000, 44725, 0.12],
    [44725, 95375, 0.22],
    [95375, 182100, 0.24],
    [182100, 231250, 0.32],
    [231250, 578125, 0.35],
    [578125, 999999999, 0.37],
];
var MARRIED_JOINTLY_TAX_INCOME_THRESHOLDS = [
    [0, 22000, 0.1],
    [22000, 89450, 0.12],
    [89450, 190750, 0.22],
    [190750, 364200, 0.24],
    [364200, 462500, 0.32],
    [462500, 693750, 0.35],
    [693750, 999999999, 0.37],
];
var MARRIED_SEPARATELY_TAX_INCOME_THRESHOLDS = [
    [0, 11000, 0.1],
    [11000, 44725, 0.12],
    [44725, 95375, 0.22],
    [95375, 182100, 0.24],
    [182100, 231250, 0.32],
    [231250, 346875, 0.35],
    [346875, 999999999, 0.37],
];
var HEAD_OF_HOUSEHOLD_TAX_INCOME_THRESHOLDS = [
    [0, 15700, 0.1],
    [15700, 59850, 0.12],
    [59850, 95350, 0.22],
    [95350, 182100, 0.24],
    [182100, 231250, 0.32],
    [231250, 578100, 0.35],
    [578100, 999999999, 0.37],
];
exports.filingDetail = {
    SINGLE: { standardDeduction: 13850, taxDetail: SINGLE_TAX_INCOME_THRESHOLDS },
    HEAD_OF_HOUSEHOLD: {
        standardDeduction: 20800,
        taxDetail: HEAD_OF_HOUSEHOLD_TAX_INCOME_THRESHOLDS,
    },
    MARRIED_JOINTLY: {
        standardDeduction: 27700,
        taxDetail: MARRIED_JOINTLY_TAX_INCOME_THRESHOLDS,
    },
    MARRIED_SEPARATELY: {
        standardDeduction: 13850,
        taxDetail: MARRIED_SEPARATELY_TAX_INCOME_THRESHOLDS,
    },
};
//Stop paying into social security at $160,200 GROSS INCOME
exports.SOCIAL_SECURITY_TAX = 0.062;
exports.MAX_SOCIAL_SECURITY_PAID = 9932.4;
exports.MEDICARE_TAX = 0.0145;
// Wages above $200,000
exports.ADDTL_MEDICARE_TAX = 0.009;
// 1099 tax info
exports.SOCIAL_SECURITY_1099 = 0.124;
exports.MEDICARE_TAX_1099 = 0.029;
